import React, { useCallback, useState } from "react";
import styled from "styled-components";
import {
  withRouter,
  useHistory,
  useParams,
  useLocation
} from "react-router-dom";
import { transparentize } from "polished";
import { parseQueryString } from "../../utils/paths";
import { stringify } from "query-string";

import media from "../../utils/media";

interface IStyledSearchInput {
  theme: { scriptDirection: string; uiFont: string; primaryText: string };
}
const StyledSearchInput = styled.input<IStyledSearchInput>`
  flex: 1;
  border: none;
  background: none;
  transition: all 0.5s ease;
  direction: ${props => props.theme.scriptDirection || "ltr"};
  font-family: ${props => props.theme.uiFont};
  padding: 0.3em 0.5em;
  font-size: 1.1rem;
  color: ${props => props.theme.primaryText};
  border-radius: 2px;
  transition: all 0.5s;
  width: 400px;
  max-width: calc(100vw - 204px);
  ${media.desktop`
    background: none;
    padding: 0.65rem;
    color: ${(props: IStyledSearchInput) => props.theme.primaryText};
  `} &::placeholder {
    color: ${transparentize(0.6, "#FFFFFF")};
  }
  &:focus {
    outline: none;
  }
`;

interface SearchInputProps {
  match: {
    params: {
      bibleId: string;
    };
  };
  history: {
    push: (path: string) => void;
  };
}

const SearchInput = () => {
  const searchInput = useCallback(node => {
    if (node) node.focus();
  }, []);
  const history = useHistory();
  const { bibleId } = useParams();
  const location = useLocation();
  const [query, setQuery] = useState(() => {
    const queryString = parseQueryString(location.search || "");
    return queryString.q || "";
  });

  const handleChange = (e: React.FormEvent<HTMLInputElement>) =>
    setQuery(e.currentTarget.value);

  const handleSearchSubmit = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.keyCode === 13) {
      event.preventDefault();
      if (!query) return;
      if (!location.pathname.includes("search")) history.push(location);
      const newQueryString = stringify({
        ...parseQueryString(location.search),
        q: query,
        embedInit: undefined
      });
      history.push(`/bible/${bibleId}/search?${newQueryString}`);
    }
  };

  return (
    <StyledSearchInput
      ref={searchInput}
      value={query}
      onChange={handleChange}
      onKeyDown={handleSearchSubmit}
    />
  );
};

export default withRouter(SearchInput);
